// removed by extract-text-webpack-plugin
module.exports = {"nothing":"_1yniGNqbJOZ04XVm1bRLsT","item":"kPU9sxBJC9d6xdeSlAytW","unread":"_2QKodp7uGJr_Yl70p_fRRP","text":"_1KJZ1axfFArAjyN6v0_b7N","items":"CJIow5Nww3RUvjzk1Ne8l","boxNotification":"_3dVVLZ75ieh_EAWq1viTfg"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/UserNotifications/style.css
// module id = 378
// module chunks = 38